import { AssetLink } from '../../AssetLink/AssetLink';
import { AssetThumbnail } from '../AssetThumbnail';
import { Title } from '../shared/Title/Title';
import { Description } from '../shared/Description/Description';
import { ProgressBar } from '../shared/ProgressBar/ProgressBar';
import { useAssetWatchtimeData } from '../../utils/useAssetWatchtimeData';
import { getAssetAgeLimit } from '../../../shared/helpers/assetHelpers';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { ImageSources } from '../../../helpers/images';
import type { FC } from 'react';

import * as styles from './AssetHorizontal.module.scss';

export interface AssetHorizontalProps {
  asset: SvpAssetAdditional;
  title: string;
  description?: string | null;
  imageSources?: ImageSources;
  duration?: number;
  onClick?: () => void;
}

export const AssetHorizontal: FC<AssetHorizontalProps> = (props) => {
  const { asset, title, imageSources, duration, onClick, description } = props;

  const { position, isWatched } = useAssetWatchtimeData(
    asset.id,
    asset.provider
  );

  const progress =
    position && duration ? position / (duration / 1000) : undefined;

  return (
    <AssetLink asset={asset} className={styles.assetLink} onClick={onClick}>
      <div className={styles.asset}>
        <div className={styles.thumbnailWrapper}>
          <AssetThumbnail
            imageSources={imageSources}
            duration={duration ? duration / 1000 : undefined}
            isComplete={isWatched}
            ageLimit={getAssetAgeLimit(asset)}
          />
        </div>
        <div className={styles.info}>
          <Title title={title} className={styles.titleInAsset} />
          {description && <Description description={description} />}
          <ProgressBar value={progress} />
        </div>
      </div>
    </AssetLink>
  );
};
